import {connectStream} from '../../lib/bastetjs/utils/connectStream';
import _ from 'lodash';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import {injectIntl} from 'react-intl';
import {Link} from 'react-router-dom';

import {Loading} from '../../components/shared/Loading';
import {StartList} from '../../components/startList/StartList';
import {
  isLoggedIn,
  getTokenRacerId
} from '../../utils/isLoggedIn';
import {styles} from './styles';
import {isTodayOrFuture} from '../../utils/date';
import {imageStyles, textStyles} from '../../shared/styles';
import { AddRaceModal } from '../../components/modal/AddRaceModal';
import {
  getDateOptions,
  adjustRaces
} from '../../utils/resultsHelpers';
import {modal} from '../../data/ModalsStream';
import {StartListFilter} from '../../components/eventStartList/Filters';
import {AthletePhoto} from '../../components/athlete/AthletePhoto';
import {EventCalendar} from '../../components/modal/EventCalendar';
import {LogInOrSignUp} from '../../components/modal/LogInOrSignUp';
import {
  loadEvent,
  getEventCourse,
  setEventCourse,
  fetchUserStartListEntries,
  fetchUserRosterEntries,
  fetchStartListForEventCourse,
  getStartListForEventCourse,
  getUserStartListEntries,
  getUserRosterEntries,
  fetchRosterForEventCourse,
  getRosterForEventCourse,
  getPage,
  setPage
} from '../../data/StartListStreams';
import {Pager} from '../../components/pager/Pager';
import {configs} from '../../configs';

/**
 * Component that renders start list for event
 */
export class EventStartListComponent extends Component {
  static propTypes = {
    eventId: PropTypes.number,
    eventName: PropTypes.string,
    event: PropTypes.object,
    races: PropTypes.object,
    isMobile: PropTypes.bool,
    action: PropTypes.oneOf(['create', '', 'following', 'all']),
    athlete: PropTypes.object.isRequired,
    page: PropTypes.number,
    startList: PropTypes.object,
    isRoster: PropTypes.bool.isRequired,
    t: PropTypes.func
  };

  static defaultProps = {
    event: null,
    races: {isLoading: true},
    isMobile: false,
    eventOptions: [],
    page: 0,
    startList: {fetching: true}
  };

  constructor(props, context) {
    super(props, context);
    this.onSearch = _.debounce(this.onSearch, 600);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.event && !this.props.event) {
      setTimeout(this.executeAction, 0);
    }

    if (!_.isEqual(nextProps.eventCourse, this.props.eventCourse) && (nextProps.eventCourse || {}).eventCourseId) {
      setPage(0);

      if (this.props.isRoster) {
        fetchRosterForEventCourse(this.props.eventId, nextProps.eventCourse.eventCourseId, 0);
      }
      else {
        fetchStartListForEventCourse(this.props.eventId, nextProps.eventCourse.eventCourseId, 0);
      }
    }

    if (!_.isEqual(this.props.page, nextProps.page) && (this.props.eventCourse || {}).eventCourseId) {
      if (this.props.isRoster) {
        fetchRosterForEventCourse(this.props.eventId, this.props.eventCourse.eventCourseId, nextProps.page);
      }
      else {
        fetchStartListForEventCourse(this.props.eventId, this.props.eventCourse.eventCourseId, nextProps.page);
      }
    }
  }

  componentDidMount() {
    if (this.props.isRoster) {
      fetchUserRosterEntries(this.props.eventId);
    }
    else {
      fetchUserStartListEntries(this.props.eventId);
    }
  }

  executeAction = () => {
    const {action} = this.props;
    switch(action) {
      case 'create':
        modal.open(AddRaceModal.modalName);
        break;
      default:
        break;
    }
  };

  /**
   * Set value from search input
   * @param {String} searchTerm
   */
  onSearch = (searchTerm) => this.setState({searchTerm});

  /**
  * Check if component is in loading state
  * @return {boolean}
  */
  isLoading = () => {
    const {event, startList} = this.props;

    return !event || !!startList.fetching;
  };

  /**
   * Filter component callback, will update this.state.filters
   * @return {boolean}
   */
  hasStartList = () => {
    const { nextRaceDate, prevRaceDate } = this.props.master;
    return isTodayOrFuture(nextRaceDate) || isTodayOrFuture(prevRaceDate);
  };

  courseDisplayTableTitle = (courseName) =>
    <div>
      {courseName}
    </div>;


  renderAddNextYear = () => {
    if(!this.props.event) return null;
    const {
      event: {MasterEvent: {Name = ''} = {}},
      master,
      t
    } = this.props;

    if (!Name) {
      return (
        <div style={styles.loaderContainer}>
          <div style={imageStyles.loadingPosition}>
            <Loading timeoutMessage={t('Still thinking...')}/>
          </div>
        </div>
      );
    }

    const { affiliate: {affiliateID } = {} } = master;
    if (affiliateID) {
      return (
        <div
          id="affiliate-start-list"
          style={{textAlign: 'center', marginTop: 60}}>
          {t('This event is managed by an Athlinks affiliate partner. Please'
            + ' check back later.')}
        </div>
      )
    }

    return (
      <div style={{textAlign: 'center'}}>
        <div style={styles.noListMessage}>
          {t('There aren\'t any start lists for the next {{eventName}}.', {eventName: Name})}
        </div>
      </div>
    );
  };

  afterAdd = ({EventID, EventCourseID, CoursePatternID}) => {
    const {eventCourse: {coursePatternId, courseId}} = this.props;

    setEventCourse(this.props.master.masterEventID, {
      eventId: EventID,
      eventCourseId: EventCourseID,
      coursePatternId: CoursePatternID || coursePatternId,
      courseId
    });

    if(this.props.isRoster) {
      fetchUserRosterEntries(EventID);
    }
    else {
      fetchUserStartListEntries(EventID);
    }
  };

  getStarter(userEntries, courseIds) {
    return _.find(userEntries.result, (entry) => courseIds.includes(entry.CourseId));
  }

  render() {
    const {
      event,
      eventCourse,
      eventName,
      isMobile,
      races,
      master: {masterEventID},
      courseId,
      eventId,
      eventOptions = [],
      startList,
      athlete,
      intl,
      userStartListEntries = {},
      page,
      isRoster,
      t
    } = this.props;

    // TODO: HEAVY business logic going on here, can refactor to improve performance

    const defaultCourseId = races.races.find((race) => race.eventId === eventId);
    const eventsDropdown = getDateOptions(adjustRaces(races.races), intl);
    const hasStartList = this.hasStartList();
    const selectedEvent = eventOptions.find((event) => event.id === eventId) || {courses:[]};
    const selectedCourse = selectedEvent.courses.find(
      (course) => course.eventCourseID === courseId);
    const selectedEventDate = new Date((eventsDropdown.find(
      (event) => event.value === eventId) || {}).startEpoch * 1000);

    const athletes = this.isLoading() ? [] : startList.starters;
    const totalEntries = this.isLoading() ? 0 : startList.totalEntries;
    const starter = this.getStarter(userStartListEntries, [courseId, _.get(eventCourse, 'courseId', 0)]);
    const isDirtyKanza = eventId === 656425; // TODO: get rid of this

    const showAddYourself = isRoster ? false :
      !startList.fetching &&
      !userStartListEntries.fetching &&
      !starter &&
      isTodayOrFuture(selectedEventDate);

    const courseInfo = selectedCourse && this.courseDisplayTableTitle(selectedCourse.courseName);
    const loggedInRacer = getTokenRacerId();

    return (
      <div className="container">
        <div style={isMobile ? styles.contentCardMobile : styles.contentCard}>
          <div className='row'>
            <div className='col-12'>
              {
                !isMobile &&
                <h2 style={styles.startListTitleContainer} id='start-list'>
                  {t('Start List')}
                </h2>
              }
              {
                isDirtyKanza && !isRoster &&
                <DirtyKanzaLinks isMobile={isMobile}/>
              }
              {
                !hasStartList && !isRoster && !isDirtyKanza &&
                this.renderAddNextYear()
              }
              {
                ((hasStartList && !isDirtyKanza) || isRoster) &&
                <div id='start-list-component'>
                  <div className={isMobile ? 'col-12' : 'col-12 px-0'}
                       style={styles.startListFilterContainer(isMobile)}>
                    <StartListFilter
                      masterId={masterEventID}
                      eventId={this.props.eventId}
                      eventCourseId={this.props.courseId || defaultCourseId.eventCourseId}
                      isMobile={isMobile}
                    />
                  </div>
                  {
                    selectedCourse && !isMobile &&
                    <div style={styles.raceTitle(isMobile)} id='start-list-title'>
                      {courseInfo}
                    </div>
                  }
                  {
                    !isMobile &&
                    <div style={styles.detailRow}
                         id='start-list-subtitle'
                         dangerouslySetInnerHTML={{
                           __html: !isRoster
                             ? t(
                               'There are {{resNum}} Athlinks members committed to this event',
                               {resNum: (intl.formatNumber(totalEntries))}
                              )
                             : t(
                               'There are {{resNum}} athletes registered for this event',
                               {resNum: (intl.formatNumber(totalEntries))}
                              )
                         }}
                    />
                  }
                  {
                    showAddYourself &&
                    <AddYourself
                      masterId={masterEventID}
                      eventId={eventId}
                      eventName={eventName}
                      eventCourseId={courseId}
                      isMobile={isMobile}
                      athlete={athlete}
                      starters={startList}
                      afterAdd={this.afterAdd}
                      inRace={!!starter}
                      t={t}
                    />
                  }
                  {
                    (!_.isEmpty(athletes) || startList.fetching) &&
                    <div style={{marginTop: 37}}>
                      <StartList
                        athletes={starter ? [starter].concat(athletes.filter((a) => a.RacerId !== loggedInRacer)) : athletes}
                        event={event}
                        masterId={masterEventID}
                        eventId={eventId}
                        eventName={eventName}
                        eventCourseId={courseId}
                        afterAdd={this.afterAdd}
                        isMobile={isMobile}
                        fetching={startList.fetching || false}
                        isRoster={isRoster}
                        t={t}
                      />
                      {
                        !startList.fetching &&
                        <div style={styles.pagerContainer} id='pager'>
                          <Pager
                            pageNumber={page}
                            pageSize={configs.numResultsPerPage}
                            onPage={(pageNumber) => setPage(pageNumber)}
                            total={totalEntries}
                            pageButton={{cursor: 'pointer'}}
                          />
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// TODO: DELETE ME
const DirtyKanzaLinks = ({isMobile, t}) =>
  <div className={isMobile ? 'col-12' : 'col-12 px-0'}>
    <div style={{marginBottom: 8}}>
      {t('Start lists for this event can be found at the following links:')}
    </div>
    <div>
      <Link to={'https://dirtykanza.com/dk-200-starting-list/'} target='_blank' style={textStyles.textLink2Blue}>
        {'DK-200'}
      </Link>
    </div>
    <div>
      <Link to={'https://dirtykanza.com/dk-100-starting-list/'} target='_blank' style={textStyles.textLink2Blue}>
        {'DK-100'}
      </Link>
    </div>
    <div>
      <Link to={'https://dirtykanza.com/dk-50-starting-list/'} target='_blank' style={textStyles.textLink2Blue}>
        {'DK-50'}
      </Link>
    </div>
    <div>
      <Link to={'https://dirtykanza.com/dk-25-starting-list/'} target='_blank' style={textStyles.textLink2Blue}>
        {'DK-25'}
      </Link>
    </div>
  </div>;

/**
 * Event start list component with connected streams
 */
export const EventStartList = withTranslation()(injectIntl(connectStream({
  event: ({eventId}) => loadEvent(eventId),
  eventCourse: ({master: {masterEventID}}) => getEventCourse(masterEventID),
  userStartListEntries: ({eventId, isRoster}) => {
    if(isRoster) {
      return getUserRosterEntries(eventId);
    }

    return getUserStartListEntries(eventId);
  },
  startList: ({eventId, isRoster}) => {
    if(isRoster) {
      return getRosterForEventCourse(eventId);
    }

    return getStartListForEventCourse(eventId);
  },
  page: getPage
})(EventStartListComponent)));

export const AddYourself = (props) => {
  const {
    eventName,
    isMobile,
    eventId,
    eventCourseId,
    masterId,
    athlete: {DisplayName, LogoUrls, RacerID} = {},
    afterAdd,
    inRace, //TODO: this is a bandaid for Miami, remove me!!!
    t
  } = props;

  const loggedIn = isLoggedIn();

  return (
    <div className='row mx-0' style={styles.addYourselfContainer}>
      {
        !isMobile && RacerID &&
        <div style={styles.photoContainer} className='col-3 col-md-1'>
          <AthletePhoto
            name={DisplayName}
            photo={LogoUrls}
            size='Medium'
            width={60}
            isMember={loggedIn}
          />
        </div>
      }
      <div style={styles.areYouInThisRace(isMobile)} className={isMobile ? 'col-12 col-md-8' : 'col-9 col-md-8'}>
        {
          !inRace ? t('Are you in this race?')
            : t('You\'re in the start list for this race')
        }
      </div>
      {
        !inRace &&
        <div className='col-12 col-md-3' style={styles.addYourselfButtons} id='add-yourself'>
          {
            loggedIn ?
            <EventCalendar
              control='addEventToCalendar'
              eventName={eventName}
              isMobile={isMobile}
              eventId={eventId}
              eventCourseId={eventCourseId}
              afterAdd={afterAdd}
              hasFutureDate={true}
              masterId={masterId}
              isLoggedIn={true}
              label={t('Add yourself')}
              buttonStyle={isMobile ? {margin: '3px auto'} : {float: 'right'}}
              isDarkButton={true}
              isStarter={false}
            /> :
            <LogInOrSignUp
              isMobile={isMobile}
              control='addEventToCalendar'
              buttonStyle={{float: 'right'}}
              label={t('Add yourself')}
              isLoggedIn={false}
              isDarkButton={true}
            />
          }
        </div>
      }
    </div>
  );
};



/** WEBPACK FOOTER **
 ** ./views/eventStartList/EventStartList.js
 **/